/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Sales_Range_RefundedInputs */

const en_cargos_sales_range_refunded = /** @type {(inputs: Cargos_Sales_Range_RefundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Returned`)
};

const es_cargos_sales_range_refunded = /** @type {(inputs: Cargos_Sales_Range_RefundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devueltos`)
};

/**
* | output |
* | --- |
* | "Returned" |
*
* @param {Cargos_Sales_Range_RefundedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_sales_range_refunded = /** @type {((inputs?: Cargos_Sales_Range_RefundedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Sales_Range_RefundedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_sales_range_refunded(inputs)
	return es_cargos_sales_range_refunded(inputs)
});